import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { _MindBlownBannerImage, _MindBlownDescM, _MindBlownTitleM, _VideosResponse2ContentGridData, } from "./optics";
const MindBlownPageHeroView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const mindBlownVideoList = Fold.toArray(_VideosResponse2ContentGridData, data);
    const titleM = Fold.preview(_MindBlownTitleM, data);
    const descM = Fold.preview(_MindBlownDescM, data);
    const srcM = Fold.preview(_MindBlownBannerImage, data);
    const route = mindBlownVideoList[0] && mindBlownVideoList[0].route;
    return {
        mindBlownVideoList,
        titleM,
        descM,
        srcM,
        route,
    };
};
const MindBlownPageHero = ({ mindBlownVideoList, titleM, descM, srcM, route, environment, }) => {
    const webAuthUrl = environment.authService.protocol + "://" + environment.authService.domain;
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(MindBlownPageHeroView, { read: environment, titleM: titleM, descM: descM, srcM: srcM, route: route, mindBlownVideoList: mindBlownVideoList, webAuthUrl: webAuthUrl })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, MindBlownPageHero);

